import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { KeepAwake } from '@capacitor-community/keep-awake';
import { ThemeService } from './core/services/theme.service';
import { PushNotificationService } from './core/services/push-notification.service';
import OneSignalNative from '@onesignal/capacitor-plugin';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  template: '<router-outlet />',
  styles: [':host { display: block; height: 100%; }'],
})
export class App implements OnInit {
  private theme = inject(ThemeService);
  private pushNotification = inject(PushNotificationService);

  ngOnInit(): void {
    document.body.classList.toggle('dark', this.theme.isDark());
    (screen.orientation as unknown as { lock?: (o: string) => Promise<void> }).lock?.('portrait')?.catch(() => {});

    if (Capacitor.isNativePlatform()) {
      OneSignalNative.initialize(environment.ONE_SIGNAL_APP_ID);
      OneSignalNative.Notifications.requestPermission();
      // Empêche la mise en veille / verrouillage de l'écran tant que l'app est ouverte
      KeepAwake.keepAwake().catch(() => {});
    } else {
      this.pushNotification.initializeWeb();
    }
  }
}
